import { createContext, useContext } from "react";

const PublicSessionContext = createContext(null);

export function PublicSessionProvider({ token, athleteId, children }) {
  return (
    <PublicSessionContext.Provider
      value={{ token, athleteId, isPublicView: true }}
    >
      {children}
    </PublicSessionContext.Provider>
  );
}

export const usePublicSession = () => useContext(PublicSessionContext);
